import { render } from "./PengaturanAssessment.vue?vue&type=template&id=aefc5926&scoped=true"
import script from "./PengaturanAssessment.vue?vue&type=script&lang=js"
export * from "./PengaturanAssessment.vue?vue&type=script&lang=js"

import "./PengaturanAssessment.vue?vue&type=style&index=0&id=aefc5926&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aefc5926"]])

export default __exports__